import React from 'react';
import { Box } from '@chakra-ui/react';
import pageTokens from '../../styles/pageTokens';
import defaultSizes from '../../utils/defaultSizes';

/**
 * Large faded circle — same treatment as leads stat cards, scaled for page chrome.
 */
const PageBackgroundDecor = () => (
	<Box
		position='fixed'
		top={{ base: '-100px', md: '-140px' }}
		right={{ base: '-100px', md: '-160px' }}
		w={{ base: '320px', md: '480px', lg: '700px' }}
		h={{ base: '320px', md: '480px', lg: '700px' }}
		borderRadius='full'
		bg={pageTokens.bg}
		opacity={pageTokens.decorCircleOpacity}
		pointerEvents='none'
		zIndex={0}
		aria-hidden
	/>
);

/**
 * Standard authenticated page canvas — applied in LoggedInLayout so every route
 * shares the same background and width behaviour.
 */
const PageContent = ({ children }) => (
	<Box
		w='100%'
		flex='1'
		position='relative'
		pt={defaultSizes.contentPaddingTop}
		minH={`calc(100vh - ${defaultSizes.headerHeight})`}
		sx={{ background: pageTokens.pageBackgroundGradient }}>
		<PageBackgroundDecor />
		<Box w='100%' maxW={pageTokens.contentMaxW} position='relative' zIndex={1}>
			{children}
		</Box>
	</Box>
);

export default PageContent;
